import React from "react";
import SlimCTA from "components/SlimCTA";
import { BUTTON_TAGS, UI_THEME } from "utils/constants/ui";
import { API_PATHS } from "utils/paths";
import { useUser } from "utils/selectors";

const DEFAULT_CLASSES = {
  container:
    "w-100 flex flex-column justify-between ba br2 hairline-1 pa3 items-start bg-white",
  actionsWrapper: "pt3"
};

export const TEST_MODE_SETUP_PROMPT_COPY = {
  header: "Enable test mode",
  subheader:
    "To enable test mode, you need to login to your Stripe account as a test user. Once enabled, you'll be able to complete checkout using test payment details."
};

const TestModeSetupPrompt = ({ customClasses, actions, header, subheader }) => {
  const classes = {
    ...DEFAULT_CLASSES,
    ...customClasses
  };
  const ctxHeader = header || TEST_MODE_SETUP_PROMPT_COPY.header;
  const ctxSubheader = subheader || TEST_MODE_SETUP_PROMPT_COPY.subheader;
  const user = useUser();

  return (
    <SlimCTA
      header={ctxHeader}
      subheader={ctxSubheader}
      customClasses={classes}
      actions={
        actions || [
          {
            tag: BUTTON_TAGS.ANCHOR,
            href: `${API_PATHS.STRIPE_TEST_AUTH}?uuid=${user.uuid}`,
            theme: UI_THEME.SLIM,
            copy: "Enable"
          }
        ]
      }
    />
  );
};

export default TestModeSetupPrompt;
